<template>
  <b-overlay opacity="0.75" spinner-variant="primary" :show="$root.$data.bsLoader">
    <div class="wrapper">
      <nav-bar />

      <step-1 :form="form" @componentFormSubmitted="fillComponentFormData" v-if="step == 1" :step="step" :sidebarListLinks="sidebarListLinks" :eventParentToChildComponentFrom="eventComponentForm"></step-1>
      <step-2 :form="form" @componentFormSubmitted="fillComponentFormData" v-else-if="step == 2" :step="step" :sidebarListLinks="sidebarListLinks" :eventParentToChildComponentFrom="eventComponentForm"></step-2>
      <step-3 :form="form" @componentFormSubmitted="fillComponentFormData" v-else-if="step == 3" :step="step" :sidebarListLinks="sidebarListLinks" :eventParentToChildComponentFrom="eventComponentForm" :createdUpdatedText="strataCreatedUpdated"></step-3>

      <footer-component> </footer-component>
    </div>
  </b-overlay>
</template>

<script>
import NavBar from "../../includes/NavBar.vue";
import Step1 from "./Step1.vue";
import Step2 from "./Step2.vue";
import Step3 from "./Step3.vue";
import { Form } from "vform";
import _ from "lodash";
import phoneNoMixin from "../../../../../mixins/phoneNoMixin.js";
import FooterComponent from "../../../includes/FooterComponent.vue";


export default {
  components: {
    NavBar,
    Step1,
    Step2,
    Step3,
    FooterComponent
  },
  mixins: [phoneNoMixin],
  data() {
    return {
      eventComponentForm: new Vue(),
      step: 1,
      sidebarListLinks: [
        { label: 'Create', routeTo: { name: 'strata-plan-edit', params: { step: 1 }, disabled: true } },
        { label: 'Address', routeTo: { name: 'strata-plan-edit', params: { step: 2 } }, disabled: true },
        // { label: 'Details', routeTo: { name: 'strata-plan-edit', params: { step: 3 } }, disabled: true },
      ],
      id: null,
      step: 1,
      strataCreatedUpdated:'',

      form: new Form({
        id: "",
        validate_only: "",
        validate_step: "",
        type: "SP",

        // step 1
        strata_plan_number: "",
        strata_manager_id: "",
        alternate_manager_id: "",
        building_manager_name: "",
        building_manager_email: "",
        building_manager_phone: "",
        formattedPhone: "",
        formattedEstimatedBudget: "",
        estimated_budget: "",
        abn_acn: "",

        // step 2
        building: "",
        street: "",
        suburb: "",
        state: "",
        postcode: "",
        registered_lots: "",
        attachements: [],
        site_photos: [],
        storage_filename: [],

        // step 3
      }),
    };
  },
  mounted() {
    if (this.$route.params.id != "new") {
      this.id = this.$route.params.id;
      this.fetchFormData(this.$route.params.id);
    }
    this.step = this.$route.params.step;
    this.updateSidebarDisabledLinks();
  },
  methods: {
    fillComponentFormData(stepData, stepFrom) {
      _.forEach(stepData, (value, key) => {
        this.form[key] = value;
      });
      this.submitFormData(stepFrom, 1);
    },
    handleComponentBackPress(stepFrom) {
      stepFrom == 1 && this.$router.push({ name: "manager-dashboard" });
      this.$router.push({
        name: "strata-plan-edit",
        params: { step: stepFrom - 1 },
      });
    },
    submitFormData(stepFrom, validate_only = 0) {
      this.$root.$data.bsLoader = true;
      this.form.validate_step = stepFrom;
      this.form.validate_only = stepFrom < 2 ? validate_only : 0;
      this.form
        .post("api/manager/strata-plan/updateOrCreate")
        .then((response) => {
          if (validate_only && stepFrom < 3) {
            this.strataCreatedUpdated  = response.data.strata_created_updated
            this.form.id  = response.data.strata_plan_id
            this.$root.$data.bsLoader = false;
            this.$router.push({
              name: "strata-plan-edit",
              params: { step: stepFrom + 1, id: response.data.strata_plan_id },
            }).catch((err) => {
              this.$root.$data.bsLoader = false;
            });
          } else {
            // push to previous quote edit, either new or particular id
            this.$router.push({ name: "manager-quotes" });
          }
        });
    },
    fetchFormData(id) {
      axios.post("api/manager/strata-plan/getDetails",{
        id: id,
        // load_strata_plan: 1,
        // load_invitations: 1,
        // load_categories_id: 1,
        // load_invitations_user_id: 1
      }).then((response) => {
          this.form.fill(response.data.strataplan);
          this.$root.$data.bsLoader = false;
          //Managing FIle
          this.form.attachements = [];
          _.forEach(response.data.strataplan.attachments, (value,key) => {
              let extension = value.file_name.split('.').pop();
                this.form.attachements.push({
                      extension: extension,
                      file_name:  value.file_name,
                      name: value.name,
                      temporary_path: 'empty',
                      uuid: value.uuid
                  }).catch((err) => {
                    this.$root.$data.bsLoader = false;
                  });
          });

          //Managing pphotos 
          this.form.site_photos = [];
          _.forEach(response.data.strataplan.site_photos, (value,key) => {
            let extension = value.file_name.split('.').pop();
              this.form.site_photos.push({
                    extension: extension,
                    file_name:  value.file_name,
                    name: value.name,
                    temporary_path: 'empty',
                    uuid: value.uuid
                });
          });

          //For formating manger phone number
          this.formatPhone(response.data.strataplan.strata_manager_phone);

          //For formatting estimated budget
          this.estimatedBudgetFormat();

          //Fire event to component form data
          this.eventComponentForm.$emit('event-parent-child-componentform', {data: this.form});

          //For disabling top step
          this.updateSidebarDisabledLinks();
      });
    },
     updateSidebarDisabledLinks(){
      let maxAllowedRouteStep = 1;
      
      if(this.form.building){
        maxAllowedRouteStep = 2;
      }
  
      _.each(this.sidebarListLinks, (sidebarListLink, idx) => {
        if(maxAllowedRouteStep >  idx){
          sidebarListLink.disabled = false;
        }
      })
    },
    formatPhone(strata_manager_phone) {
        this.form.building_manager_phone = strata_manager_phone ?  this.getPhoneDigitsOnly(strata_manager_phone) : null;
        this.form.formattedPhone = this.form.building_manager_phone ? this.formatPhoneForAustralia(this.form.building_manager_phone) : null;
    },
    estimatedBudgetFormat(){
      this.form.formattedEstimatedBudget = this.form.estimated_budget.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  },
  watch: {
    $route($to, $from) {
      if ($to.name == "strata-plan-edit") {
        this.step = $to.params.step;
      }
    },
  },
};
</script>
